<template>
    <div class="review-widget-wrapper">
        <h2>
            Save your details, save time
        </h2>
        <ul>
            <li>
                <img src="data:image/svg+xml;base64,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">
                <p>
                    <b>Add your personal details</b> to save time completing services next time.
                </p>
            </li>

            <li>
                <img src="data:image/svg+xml;base64,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">
                <p>
                    <b>We keep your details secure</b> so you can access and control them anytime.
                </p>
            </li>

            <li>
                <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDBweCIgaGVpZ2h0PSIzNXB4IiB2aWV3Qm94PSIwIDAgNDAgMzUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU5LjEgKDg2MTQ0KSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5tZ2UtaWNvbjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJtZ2UtaWNvbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ikdyb3VwLTMyLUNvcHktMiI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yNyI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMzIuODM0Nzg2LDAuMzE1MzAxNTk1IEwzOC4zNDc2MDU5LDAuNDE5Njc3NTIyIEwyNS41MTIxNjM5LDIxLjc0Nzk0MzUgQzI0LjY2MDgyOTUsMjMuMTYyNTgwMyAyMi44MjM4OTY4LDIzLjYxOTIyNyAyMS40MDkyNiwyMi43Njc4OTI1IEMyMS4zOTQwODA1LDIyLjc1ODc1NzQgMjEuMzc4OTgyNCwyMi43NDk0ODc1IDIxLjM2Mzk2NzcsMjIuNzQwMDg0IEwxNy4xODgyNjgzLDIwLjEyNDkwMTYgTDE3LjE4ODI2ODMsMjAuMTI0OTAxNiBMMTcuMDE4ODY5NiwxNC4zNzA2ODYyIEwyMi4zOTExNTMzLDE3LjczNTEzOCBMMzIuODM0Nzg2LDAuMzE1MzAxNTk1IFoiIGlkPSJQYXRoIiBmaWxsPSIjMTgzQTgxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy42ODMyMzgsIDEyLjMzNTMxMCkgcm90YXRlKDEuMDAwMDAwKSB0cmFuc2xhdGUoLTI3LjY4MzIzOCwgLTEyLjMzNTMxMCkgIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbD0iI0M2MEMzMCIgcG9pbnRzPSIzMC41MzMyNzY3IDEuMjE5MDYxNjEgMjcuMzQ0MDI0MiA2LjAxMzgxMDQ2IDUuMDE4OTYzOTUgNi4wMTM4MTA0NiA1LjAxODk2Mzk1IDE4Ljc5MDUzNzUgMTMuMDI2MjIwMSAyMC42NTI0OTg0IDI0LjE3NDg4OTkgMjcuMzY2NzQ1IDM3LjMzNTYyNCA1LjQxNDM2MDkxIDM5Ljc5MzYyMTkgMTAuNjIzNzczNyAyNS44MzE2MzcxIDMzLjkxMzIxOCAyNS44MTI4ODk5IDMzLjkwMTk4NzcgMjUuNzkzMzc3NCAzMy45MzUxNzQgMTAuODQ3MzIyOCAyNC45MzQyMDkxIDAuMjA4OTMzNDA0IDIyLjY2Nzg5MDMgMC4yMzUwODUyNzQgMjIuNTQ0MTg2NiAwLjIzNTM3ODM5OCAxLjIxOTA2MTYxIj48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==">
                <p>
                    It's all part of
                    <a
                        id="gov-made-easy-link"
                        class="is-internal"
                        href="https://www.nsw.gov.au/improving-nsw/premiers-priorities/government-made-easy/"
                        target="_blank"
                        @click="triggerGA('Government Made Easy Link', 'Click')"
                    >
                        making government easy
                    </a>
                    for you.
                </p>
            </li>
        </ul>
        <fieldset class="form__item form__options">
            <p class="form__help">
                Here's the new or updated details you provided while completing your application:
            </p>

            <Notice
                v-if="noSelectionError === true"
                id="tuo-no-selection-message"
                message="If you wish to save your details, please select at least one option."
                notice-type="ERROR"
            />

            <div class="form__checkboxes">
                <div
                    class="form-item select-all-checkbox"
                    data-test="select-all-update"
                >
                    <Checkbox
                        checkbox-id="tuo-review-widget-selectAllCheckBox"
                        checkbox-name="tuo-review-widget-selectAllCheckBox"
                        :checked.sync="selectAllChecked"
                        :show-error="noSelectionError"
                        label="Select All"
                        @checkboxClicked="selectAllClicked(selectAllChecked)"
                    />
                </div>

                <div class="details-list-container">
                    <div
                        v-for="(detail, index) in updatedDetailsCheckboxes"
                        :key="index"
                        class="review-item"
                    >
                        <Checkbox
                            :checkbox-id="'tuo-review-widget-' + detail.name"
                            :checkbox-name="'tuo-review-widget-' + detail.name"
                            :label="sentenceCase(detail.name)"
                            :helper-text="typeof detail.value == 'object'?
                                detail.value.displayValue:detail.value"
                            :checked.sync="detail.checked"
                            :show-error="noSelectionError"
                            @checkboxClicked="detailClicked"
                        />
                        <Badge
                            :value="detail.type"
                        />
                    </div>
                </div>
            </div>
        </fieldset>
        <p>
            For further information, please read the
            <a
                id="privacy-link"
                class="is-internal"
                href="https://www.service.nsw.gov.au/privacy"
                target="_blank"
                @click="triggerGA('Privacy Link', 'Click')"
            >
                Privacy statement
            </a>.
        </p>
        <Button
            primary
            data-test="save-update"
            :disabled="saveDisabled"
            @click="saveCustomerDetails"
        >
            Save
        </Button>
    </div>
</template>

<script>
  import Checkbox from '../components/Checkbox'
  import Badge from '../components/Badge'
  import {sentenceCase} from 'change-case'
  import Button from "../components/Button"
  import Notice from "../components/Notice"
  import gaTrackerAdapter from "../utils/gaTrackerAdapter"


  export default {
    name: 'UpdateDetails',
    components: {Button, Badge, Checkbox, Notice},
    props: {
        updatedDetails: {
            type: Array,
            default: () => []
        },
        onSaveUpdate: {
            type: Function,
            default: () => {}
        },
    },
    data: () => ({
      updatedDetailsCheckboxes: [],
      selectAllChecked: false,
      noSelectionError: false,
      saveSuccess: undefined,
      saveDisabled: false,
    }),
    async created() {
      this.updatedDetailsCheckboxes = this.updatedDetails.map(detail => {
        return {...detail, checked: false}
      })
    },
    methods: {
      sentenceCase,
      selectAllClicked(checked) {
        this.noSelectionError = false
        this.updatedDetailsCheckboxes.forEach(detail => {
          detail.checked = checked
        })
      },
      detailClicked() {
        this.noSelectionError = false
        this.selectAllChecked = this.updatedDetailsCheckboxes.every(detail => detail.checked)
      },
      saveCustomerDetails() {
        let detailsToSave = []

        this.updatedDetailsCheckboxes.filter(detail => detail.checked)
          .map(detail => detailsToSave.push(detail.name))

        if (detailsToSave.length === 0) {
          this.noSelectionError = true

          let noSelectionMessage = document.getElementById('tuo-no-selection-message')
          if (noSelectionMessage) {
            noSelectionMessage.scrollIntoView()
          }
        } else {
            this.saveDisabled = true
            this.onSaveUpdate(detailsToSave)
        }
      },
      triggerGA(category, action, label = window.location.href) {
        gaTrackerAdapter.trackEvent(category,action, label)
      }
    }
  }
</script>
<style lang="css" src="../../node_modules/@servicensw/constants/constants.css"></style>
<style lang="css" scoped src="../../node_modules/@servicensw/base/dist/base.css"></style>
<style scoped lang="scss">
    .review-widget-wrapper {
        margin-bottom: 30px;
    }
    .select-all-checkbox {
        display: inline-block;
        margin-top: 0;
    }

    .details-list-container {
        background: #f9f9f9;
        padding: 20px 20px 0;
    }

    .review-item {
        display: flex;
        align-items: baseline;
    }

    .is-internal {
        padding: 0;
    }

    h2 {
        margin-bottom: 0;
    }

    fieldset {
        padding: 0;
        border: none;
    }

    ul {
        margin-top: 0;
        margin-bottom: 0.5rem;
        border-bottom: 1px solid silver;

        li {
            background: none;
            padding: 0;
            display: flex;

            img {
                margin-right: 1rem;
            }
        }
    }

</style>
